import React from 'react';

const RejectedInfluencers = () => {
  return (
    <div>
      
    </div>
  );
}

export default RejectedInfluencers;
